import { memo } from "react";

import { cn } from "@/lib/chillnn/cn";
import { useLockBodyScroll } from "@/lib/react-use/use-lock-body-scroll";

import { CircleLoading } from "./circle";

type Props = {
	className?: string;
};

export const CircleLoadingScreen = memo(({ className }: Props) => {
	useLockBodyScroll();

	return (
		<div
			className={cn("fixed z-[999] flex h-full min-h-screen w-full items-center justify-center", className)}
			aria-label="loading"
		>
			<CircleLoading />
		</div>
	);
});

CircleLoadingScreen.displayName = "CircleLoadingScreen";
